<template>
    <b-modal id="confirm-modal" no-close-on-backdrop no-close-on-esc hide-footer centered header-class="bg-white"
        v-model="localModalShow">
        <div class="d-flex flex-column align-items-center justify-center-center my-2">
            <feather-icon id="view-modal" :icon="iconModal" :class="'text-' + type + ' mb-2'" size="80" />
            <div class="text-center">
                <h3>{{ titleModal }}</h3>
            </div>
            <div class="d-flex mt-2">
                <div id="tooltip-container">
                    <b-button :disabled="loading || disableCancel" v-if="cancel && canInsert" variant="primary-button"
                        class="mr-2" @click="cancelAction">
                        {{ cancel }}
                    </b-button>
                </div>
                <b-tooltip v-if="tooltipBtnCancel !== ''" target="tooltip-container" triggers="hover focus"
                    placement="top">
                    {{ tooltipBtnCancel }}
                </b-tooltip>
                <b-button id="button-confirm" :disabled="loading" :variant="'outline-' + type" @click="confirmAction">
                    <span v-if="loading" class="spinner-border spinner-border-sm mr-1" role="status"
                        aria-hidden="true"></span>
                    {{ action }}
                </b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { BModal, BButton, BTooltip } from 'bootstrap-vue';

export default {
    components: {
        BModal,
        BButton,
        BTooltip,
    },

    props: {
        showModal: {
            required: true,
            type: Boolean,
        },
        canInsert: {
            required: true,
            type: Boolean,
        },
        caseModal: {
            required: true,
            type: String,
        },
        infoText: {
            type: String,
        },
        disableCancel: {
            type: Boolean,
            default: false,
        },
        tooltipBtnCancel: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            loading: false,
            localModalShow: this.showModal,
            textComplement: '',
            modalTypes: [
                {
                    type: 'custom-blue',
                    case: 'marcar',
                    cancel: 'Registrar nova aplicação de dose',
                    action: 'Cancelar um registro de vacinação',
                    icon: '',
                    title: 'O que você deseja fazer?',
                    infoText: '',
                },
            ],
            type: '',
            case: '',
            action: '',
            infoTextModal: '',
            titleModal: '',
            iconModal: '',
            cancel: false,
        };
    },

    methods: {
        confirmAction(modalEvent) {
            modalEvent.preventDefault();
            this.loading = true;
            this.$emit('confirmed', modalEvent);
        },
        cancelAction(modalEvent) {
            modalEvent.preventDefault();
            this.$emit('canceled', modalEvent);
            this.localModalShow = false;
        },
    },

    watch: {
        showModal(val) {
            this.loading = false;
            this.localModalShow = val;

            this.modalTypes.forEach((item) => {
                if (item.case === this.caseModal) {
                    this.action = item.action;
                    this.case = item.case;
                    this.infoTextModal = this.infoText || item.infoText;
                    this.type = item.type;
                    this.titleModal = item.title;
                    this.iconModal = item.icon;
                    this.cancel = item.cancel;
                }
            });
        },

        localModalShow(val) {
            if (!val) {
                this.$emit('closeModal');
            }
        },
    },
};
</script>
